<template>
    <div id="app" class="h-100" :class="[skinClasses]">
        <component :is="layout">
            <router-view />
        </component>
        <b-overlay :show="show" rounded="lg" no-wrap style="z-index:99999;height:100vh !important;position:fixed !important">
            <template #overlay>
                <div id="loading-bg" class="d-flex align-items-center flex-column">
                        <img :src="isHesbaClient ? '/hasba-logo.png' : '/login.png'" alt="Logo" />
                        <b-spinner class="d-inline-block" label="Spinning"></b-spinner>
                </div>
            </template>
        </b-overlay>
        <b-overlay :show="showPost" rounded="lg" no-wrap style="z-index:99999;height:100vh !important;position:fixed !important">
          <template #overlay>
              <div>
                  <span class="d-flex"><b-spinner class="text-center ml-5 mr-5" label="Spinning"></b-spinner><h2>{{ $t('pleaseWaitWhilePostFinish')}}...</h2></span>
              </div>
          </template>
      </b-overlay>
      <b-overlay :show="showCancelPost" rounded="lg" no-wrap style="z-index:99999;height:100vh !important;position:fixed !important">
        <template #overlay>
            <div>
                <span class="d-flex"><b-spinner class="text-center ml-5 mr-5" label="Spinning"></b-spinner><h2>{{ $t('pleaseWaitWhileCancelPostFinish')}}...</h2></span>
            </div>
        </template>
    </b-overlay>
        <a
          v-if="hideActions === false && isLoginScreen === false && isShareInvoiceScreen === false && isHesbaClient"
          class="feedback-btn"
          :href="`http://wa.me/${getSupportWhatsAppNumber()}`"
          target="_blank"
          :title="$t('contactWithUs')"
        >
            <feather-icon
              icon="HeadphonesIcon"
              size="22"
              class="feedback-btn__icon"
            />
        </a>
        <div
          v-else-if="hideActions === false && isLoginScreen === false && isShareInvoiceScreen === false"
          class="feedback-btn"
          :title="$t('feedback')"
          @click="openModal"
        >
            <p class="feedback-txt">{{ $t('feedback') }}</p>
        </div>
        <div v-if="isShareInvoiceScreen === false && isHesbaClient === false">
          <a :href="`http://Wa.me/${getSupportWhatsAppNumber()}`" class="float" target="_blank" :title="$t('contactWithUs')">
          <i class="my-float">
            <img src="@/assets/images/icons/whatsapp.png" class="float-icon" alt="" srcset="">
          </i>
          </a>
        </div>
        <b-modal no-close-on-backdrop
                 ref="feedback-modal"
                 cancel-variant="outline-secondary"
                 centered
                 size="lg"
                 hide-footer
                 :title=" $t('feedback') ">
            <g-form @submit="send">
                <b-row>
                    <!-- media -->
                    <b-media no-body class="d-block m-auto text-center">
                        <b-media-aside>
                            <b-link>
                                <b-img ref="previewEl"
                                       rounded
                                       height="150"
                                       width="200"
                                       :src="selectedItem.screenShot"
                                       v-if="selectedItem.screenShot" />
                            </b-link>
                            <!--/ avatar -->
                        </b-media-aside>

                        <b-media-body class="mt-75 ml-75">
                            <!-- upload button -->
                            <b-button variant="primary"
                                      size="sm"
                                      class="mb-75 mr-75"
                                      @click="$refs.imgupload.$el.click()">
                                {{ $t('addImage') }}
                            </b-button>
                            <b-form-file @change="onFileChanged"
                                         ref="imgupload"
                                         accept=".jpg, .png, .gif"
                                         :hidden="true"
                                         plain />
                            <!--/ upload button -->
                        </b-media-body>
                    </b-media>
                    <!--/ media -->
                    <!-- <img :src="selectedItem.screenShot" v-if="selectedItem.screenShot" style="height: 100px;width: 200px;" class="border m-auto shadow text-center"> -->
                    <b-col md="12">
                        <!-- Title  -->
                        <g-field id="title"
                                 :value.sync="selectedItem.title"
                                 label-text="title"
                                 rules="required"
                                 name="title" />
                    </b-col>
                    <b-col md="12">
                        <!-- phone  -->
                        <b-form-group>
                            <g-field :value.sync="selectedItem.phone" rules="required" label-text="phone" />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <!-- email  -->
                        <g-field id="email"
                                 :value.sync="selectedItem.email"
                                 label-text="email"
                                 rules="email|required"
                                 name="email" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <!-- notes -->
                        <b-form-group :label="$t('textMessage')">
                            <b-form-textarea v-bind:class="isDiscribed ? '' : 'border-danger'"
                                             id="textarea"
                                             v-model="selectedItem.message"
                                             rules="required"
                                             label="Notes"
                                             rows="3"
                                             max-rows="6" />
                            <small style="font-size: 0.92rem;font-weight: 700;" v-if="!isDiscribed" class="text-danger">
                                {{ $t('youShoudDiscribeTheIssue')}}
                            </small>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <hr />
                    </b-col>
                    <b-col cols="6" class="d-flex justify-content-start">
                        <b-button class="mx-1" type="submit" variant="primary" data-action-type="save" v-permission="$route.meta.permission">
                            {{ $t('send') }}
                        </b-button>
                    </b-col>
                    <b-col cols="6" class="d-flex justify-content-end">
                        <b-button class="mx-1" variant="outline-instagram" @click="makeAction">
                            <feather-icon icon="CameraIcon"
                                          class="primary" />
                        </b-button>
                    </b-col>
                </b-row>
            </g-form>
        </b-modal>
    </div>
</template>
<script src="@/pages/Shared/html2canvas.js"></script>
<script src="@/pages/Shared/html2canvas.js"></script>
<script>
// This will be populated in `beforeCreate` hook
import navMenuItems from '@/navigation/vertical';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig';
import { provideToast } from 'vue-toastification/composition';
import { watch } from '@vue/composition-api';
import useAppConfig from '@core/app-config/useAppConfig';

import { useWindowSize, useCssVar } from '@vueuse/core';

import store from '@/store';
import { BIconNutFill } from 'bootstrap-vue';
import {getSupportWhatsAppNumber} from '@/libs/appHost';
const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue');
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue');
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue');

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  data() {
    return {
      navMenuItems,
      pathName: this.$route.name,
      hideActions: false,
      isDiscribed: false,
      selectedItem: {
        screenShot: '',
        title: '',
        phone: '',
        email: '',
        message: ''
      },
      fontStyle: `font-family: ${'Cairo'}`
    };
  },
  computed: {
    ...mapGetters({
      show: 'app/overlay',
      showPost: 'app/postOverlay',
      showCancelPost: 'app/postCancelOverlay',
    }),
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full';
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
    isLoginScreen(){
      if (this.$route.name === 'login') return true
      if (this.$route.name === 'shareInvoice') return true
      return false
    },
    isShareInvoiceScreen(){
      if (this.$route.name === 'shareInvoice' || this.$route.name === 'SmartMenu') return true
      return false
    },
    isPostVouchers(){
      if (this.$route.name === 'post-vouchers') return true
      return false
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout');

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    });

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val);
    });
    return {
      skinClasses,
    };
  },
  mounted() {
    this.$i18n.locale = this.currentLang;
    this.$store.dispatch('appConfig/changeLang', this.$i18n.locale || 'en');
    if (this.profile.userId || this.profile.isAdmin) {
      this.getBranches();
      this.$store.dispatch('app/fetchAccountsEnabled');
    }
    window.localStorage.USERID = this.profile.userId;
    window.localStorage.USERNAME = this.profile.userName;
    this.selectedItem.phone = this.profile.phone;
    this.selectedItem.email = this.profile.email;
  },
  watch: {
    profile(newVal) {
      if (newVal.isAdmin || this.profile.userId) {
        this.getBranches();
        this.$store.dispatch('app/fetchAccountsEnabled');
      }
      window.localStorage.USERID = this.profile.userId;
      window.localStorage.USERNAME = this.profile.userName;
      this.selectedItem.phone = this.profile.phone;
      this.selectedItem.email = this.profile.email;
    },
    currentLang(newVal, oldVal) {
        // Detect the current language dynamically (you can replace this with your actual language detection logic)
        // const currentLanguage = localStorage.getItem('@LANG');
        document.body.classList.remove(`font-${oldVal}`);
        // Apply the appropriate font class to the <body> element
        document.body.classList.add(`font-${newVal}`);
    }
  },
  methods: {
    getSupportWhatsAppNumber() {
      return getSupportWhatsAppNumber();
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      const fileSize = file.size / 1024 / 1024;
      if (fileSize <= 1) {
        this.selectedItem.imageExtension = file.name.split('.').pop();
        this.toBase64(file).then((file1) => {
          this.selectedItem.base64Image = file1.split(',').pop();
        });
        this.selectedItem.screenShot = URL.createObjectURL(file);
      } else {
        this.doneAlert({ text: this.$t('fileSizeExceedsOneMiB'), type: 'error' });
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    takeScreenShot(){
    const captureElement = document.body;
    html2canvas(captureElement)
        .then(canvas => {
            canvas.style.display = 'none';
            document.body.appendChild(canvas)
            // this.canvas = canvas
            return canvas
        })
        .then(canvas => {
            const image = canvas.toDataURL('image/png')
            var file = this.dataURLtoFile(image, 'imageFile.png')
            this.selectedItem.imageExtension = file.name.split('.').pop();
            this.toBase64(file).then((file1) => {
              this.selectedItem.base64Image = file1.split(',').pop();
            });
            this.selectedItem.screenShot = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.click()
            canvas.remove()
        })
    },
    dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    hide() {
      this.hideActions = true
    },
    makeAction() {
      this.hide()
      this.$refs['feedback-modal'].hide();
        setTimeout(() => {this.takeScreenShot()
        this.hideActions = false;
        this.openModal();
        }, 500);
    },
    closeModal() {
      this.$refs['feedback-modal'].hide();
      this.selectedItem = {};
      this.selectedItem.phone = this.profile.phone;
      this.selectedItem.email = this.profile.email;
    },
    openModal() {
      this.$refs['feedback-modal'].show();
    },
    beforeSaveValidation() {
      if (!this.selectedItem.message) {
        this.isDiscribed = false
        return false;
      }
      this.isDiscribed = true;
      return true;
    },
    send(){
      if (!this.beforeSaveValidation()) return;
      this.create({ url: 'SupportTicket', data: this.selectedItem })
      .then(() => {
        this.doneAlert({ text: this.$t('sendSuccessfully') });
        this.closeModal();
      });
    },
    ...mapActions({
      setBranches: 'app/setBranches',
      setYears: 'app/setYears',
    }),
    ...mapMutations({
      setCompany: 'app/setCompany',
      setCurrentYear: 'app/setCurrentYear',
      setCurrentBranch: 'app/setCurrentBranch',
    }),
    getBranches() {
      this.get({ url: 'aggregates/StartUp' })
        .then((data) => {
          this.setBranches(data.Branches);
          this.setCompany(data.CurrentCompany);
          this.mainCompany = data.CurrentCompany;
        }).then(() => {
          this.get({ url: 'Branches', id: this.branchId, showOverLay: false }).then((data) => {
          this.setCurrentBranch(data);
        })
        }).then(() => {
          if(!this.branchId
          && this.branches.length > 0
          ) {
            this.setCurrentBranch(this.branches[0]);
          }
        }).then(() => {
          this.get({ url: 'FiscalYears/lookup' })
        .then((data) => {
          if (this.profile.isAdmin || this.profile.permissions.indexOf('viewAllFiscalYears') > -1) {
            const dtaLength = data.length
            data.push({
              year: null,
              startDate: data[0].startDate,
              endDate: data[dtaLength - 1].endDate,
            })
            this.setYears(data);
          }
          if (this.profile.isAdmin === false && this.profile.permissions.indexOf('viewFiscalYears') === -1) {
          this.setYears(data);
          }
          if (this.profile.isAdmin === false && this.profile.permissions.indexOf('viewFiscalYears') > -1) {
            this.setYears(data);
          }
          if (JSON.stringify(this.currentYear) === '{}') {
            const year = { ...(data.find((item) => item.year === new Date().getFullYear())) }
            this.setCurrentYear(year)
          }
        }).catch(() => {          
          if (this.profile.isAdmin === false && this.profile.permissions.indexOf('viewFiscalYears') === -1) {
            this.setYears(data);
          }
        })
        })
        .then(() => {
          this.get({ url: 'FavoriteRoutes' }).then((data) => {
            if (data.length > 0) {
              data.forEach((res) => {
                this.navMenuItems.forEach((parent) => {
                  if (parent.children) {
                    parent.children.forEach((children) => {
                      if (res.routeUrl === children.route) {
                        res.title = children.title;
                      }
                    });
                  }
                });
              this.favMenu = data;
              localStorage.favMenu = JSON.stringify(this.favMenu);
            });
            } else {
              this.favMenu = [];
              localStorage.favMenu = JSON.stringify(this.favMenu);
            }
        });
        });
    },
  },
};
</script>
<style>
    .font-en,
    .font-ar {
      font-family: 'Cairo', sans-serif !important; /* Replace 'ar' with your actual font name */
    }

    * {
        word-wrap: normal;
        letter-spacing: normal;
    }

    #screenImage canvas {
        width: 200px !important;
        height: 100px !important;
    }

    .html2canvas-container {
        width: 100% !important;
        height: 3000px !important;
    }

    #example-datepicker__dialog_ {
        left: auto !important;
    }

    .dateLabel {
        margin-bottom: 7px;
    }

    .payment-section {
        border: 1px solid #7063ea;
        border-radius: 15px;
    }

    .tree-text {
        font-size: 15px;
    }

    .toggle-icon {
        font-size: 16px;
        text-align: center;
    }

    .tree-icon {
        margin-right: 5px !important;
    }

    .text-nowrap {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    /* .nav-fill {
        box-shadow: 0 2px 5px 0 rgb(34 41 47 / 16%), 0 2px 10px 0 rgb(34 41 47 / 12%);
    } */

    button:disabled {
        cursor: not-allowed;
    }

    @media (max-width: 767px) {
        .table-responsive .select-size-sm {
            position: static !important;
        }
    }

    @media (min-width: 768px) {
        .table-responsive {
            overflow: visible;
        }
    }

    .introjs-tooltip-title {
        color: #1e52bf;
    }

    .introjs-skipbutton {
        color: #ea5455;
    }

    .feedback-btn {
        position: fixed;
        position-attachment: fixed;
        width: 45px;
        height: 100px;
        background: #ea5455 !important;
        top: 45%;
        right: 0;
        border: none;
        box-shadow: 0 1px 20px 1px #ea5455 !important;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        cursor: pointer;
        transition: 0.2s ease-out;
    }

        .feedback-btn:hover {
            width: 50px;
        }

    .feedback-txt {
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        position: absolute;
        white-space: nowrap;
        right: -15px;
        left: -10px;
        top: 40px;
        color: #fff;
        transition: 0.2s ease-out;
    }

    .feedback-btn:hover .feedback-txt {
        right: -6px;
    }
    .float{
      position:fixed;
      width:56px;
      height:56px;
      bottom:20px;
      right:30px;
      background-color:#25d366;
      color:#FFF;
      border-radius:50%;
      display:flex;
      align-items:center;
      justify-content:center;
      text-align:center;
      font-size:30px;
      box-shadow: 0 4px 14px rgba(37, 211, 102, 0.45);
      z-index:100;
      line-height:0;
      text-decoration:none;
      overflow:hidden;
    }
    .float-icon{
      position:static;
      width:28px;
      height:28px;
      margin:0;
      padding:0;
      background:transparent;
      border-radius:0;
      box-shadow:none;
      object-fit:contain;
      display:block;
    }
    .my-float{
      margin:0;
      display:flex;
      align-items:center;
      justify-content:center;
      width:100%;
      height:100%;
    }
    .btn-whatsApp {
      border-color: #25d366 !important;
      background-color: #25d366 !important;
    }
    .completedItem{
      text-decoration: line-through !important;
      color: firebrick !important;
    }
    .bg-modified-success {
      background: rgb(40 199 111 / 34%) !important
    }
    .rest-check .custom-control-label::before, .rest-check .custom-control-label::after {
      height: 22px !important;
      width: 22px !important;
    }
    .flip-card__top[data-v-cff81de8], .flip-card__bottom[data-v-cff81de8], .flip-card__back-bottom[data-v-cff81de8], .flip-card__back[data-v-cff81de8]::before, .flip-card__back[data-v-cff81de8]::after {
  color: #f8f8f8 !important;
}
.flip-card__top[data-v-cff81de8], .flip-card__bottom[data-v-cff81de8], .flip-card__back-bottom[data-v-cff81de8], .flip-card__back[data-v-cff81de8]::before, .flip-card__back[data-v-cff81de8]::after {
  color: #f8f8f8 !important;
}
.flip-clock__piece[data-v-cff81de8] {
    display: inline-block;
    margin: 0 0.2vw;
    margin-right: 0px !important;
}
.apexcharts-legend-marker {
    margin-right: 8px !important;
}
.bg-modified-yellow{
  background: rgb(228 230 75 / 65%) !important;
}
.embed-responsive {
  height: 100% !important;
}
.status-card .card-body {
  padding-bottom: 0.25rem !important;
  padding-top: 0.25rem !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
[dir="rtl"] .v-select[dir=rtl] .vs__dropdown-menu{
  text-align: right !important;
}
[dir="rtl"] .vs__clear{
  margin-left: 5px !important;
}
[dir="rtl"] .tree {
  text-align: right !important;
}
[dir=rtl] .tree-node .tree-icon {
  transform: scaleX(-1);
}
.page-item:first-child .page-link,
.page-item:last-child .page-link,
[dir='rtl'] .page-item:first-child .page-link,
[dir='rtl'] .page-item:last-child .page-link {
  border-radius: 999px !important;
  border-top-left-radius: 999px !important;
  border-top-right-radius: 999px !important;
  border-bottom-left-radius: 999px !important;
  border-bottom-right-radius: 999px !important;
}
.tree-default.tree-checkbox-selection .tree-selected>.tree-checkbox, .tree-default .tree-checked>.tree-checkbox {
    transform: scaleX(1);
}
/*.content.app-content{
      background: url('@/assets/images/pages/ramadan-bg.png') no-repeat center center;
      background-size: cover;
}*/
</style>
